import {createAction} from 'redux-act'

export const setInsuranceModalVisible = createAction('SET_INSURANCE_MODAL_VISIBLE')
export const setInsuranceForm = createAction('SET_INSURANCE_FORM')


